

/**
 * BlitzTextDisplay - Displays the current item's title and body text
 * (revised 2026-05-18: takes an optional `title` prop so the chapter
 * title or key-point title is surfaced above the body).
 */
function BlitzTextDisplay({ title, text, isLoading }) {
  if (isLoading) {
    return (
      <div className="bg-gray-800/50 rounded-lg p-6 animate-pulse">
        <div className="h-5 bg-gray-700 rounded w-1/2 mb-4" />
        <div className="h-4 bg-gray-700 rounded w-3/4 mb-3" />
        <div className="h-4 bg-gray-700 rounded w-full mb-3" />
        <div className="h-4 bg-gray-700 rounded w-5/6 mb-3" />
        <div className="h-4 bg-gray-700 rounded w-2/3" />
      </div>
    );
  }

  if (!title && !text) {
    return (
      <div className="bg-gray-800/50 rounded-lg p-6 text-center">
        <p className="text-gray-400">No summary text available</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-800/50 rounded-lg p-6">
      {title && (
        <h2 className="text-white text-xl font-semibold mb-3">{title}</h2>
      )}
      {text ? (
        <p className="text-gray-100 text-lg leading-relaxed whitespace-pre-wrap">
          {text}
        </p>
      ) : (
        <p className="text-gray-400 italic">No text available for this item yet.</p>
      )}
    </div>
  );
}

export default BlitzTextDisplay;

